import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleFill2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M64 117.333C93.4552 117.333 117.333 93.4552 117.333 64C117.333 34.5448 93.4552 10.6667 64 10.6667C34.5448 10.6667 10.6667 34.5448 10.6667 64C10.6667 93.4552 34.5448 117.333 64 117.333Z",
		stroke: "currentColor",
		strokeWidth: 10.6667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M64 30C64 27.2386 66.2476 24.967 68.9864 25.3201C72.3943 25.7594 75.7366 26.6482 78.9247 27.9687C83.6564 29.9286 87.9557 32.8014 91.5772 36.4228C95.1986 40.0443 98.0714 44.3436 100.031 49.0753C101.352 52.2634 102.241 55.6057 102.68 59.0136C103.033 61.7524 100.761 64 98 64L69 64C66.2386 64 64 61.7614 64 59L64 30Z",
		fill: "currentColor"
	})]
});
export default SvgCircleFill2;
